import { TObtenerDatosFormularioModel } from '@/models/ObtenerDatosFormulario.model';
import { encryptWithPublicPem } from '@/utils/jweEncryptionService';

export class ObtenerDatosFormularioHelper {

  static async cifrarDatosEntrada(request: TObtenerDatosFormularioModel, publicKeyPem: string): Promise<string> {

    if (!request || !request.tipoIdentificacion || !request.numeroIdentificacion) {
      throw new Error('Invalid request data');
    }

    const encryptedData = await encryptWithPublicPem(request, publicKeyPem);

    const encryptedDataString = JSON.stringify(encryptedData);

    return encryptedDataString;
  }
}
